import { useContext } from 'react';
import UserContext, { UserContextContent } from '../UserContext';

export default (): UserContextContent => useContext(UserContext);
